(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/services/order-tickets.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/services/order-tickets.js');
"use strict";

const {
  account_services: accountServices,
  dialogs
} = svs.tur.pay;
const {
  getLatestAccountBalance,
  getAccountBalanceParams,
  getConfirmPaymentOptions
} = svs.ticketsOrderHome.utils;
function ticketsPriceSum(tickets) {
  return tickets.reduce((sum, _ref) => {
    let {
      price,
      count
    } = _ref;
    return sum + price * count;
  }, 0);
}
const createMailBoxPlayerOrderRequest = ticketsToOrder => ({
  referenceId: svs.utils.svsuid(),
  orderItems: ticketsToOrder.map(function () {
    let ticket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      productCode: parseInt(ticket.id, 10),
      quantity: ticket.count
    };
  })
});
const orderTicketsHome = async _ref2 => {
  let {
    next,
    tickets
  } = _ref2;
  svs.ui.loader.show();
  try {
    const request = createMailBoxPlayerOrderRequest(tickets);
    const {
      response
    } = await svs.tur.apiCaller.ticketgames.postMailboxPlayerOrder({
      data: request
    });
    next({
      response
    });
  } catch (e) {
    svs.tur.pay.logger.error("Ordered ".concat(tickets.map(_ref3 => {
      let {
        id,
        name,
        count
      } = _ref3;
      return "".concat(count, " st ").concat(name, "(").concat(id, ")");
    }).join(','), " failed: ").concat(e));
    next({
      error: e
    });
  }
  svs.ui.loader.hide();
};
function handleOrderTicketsResult(_ref4) {
  let {
    next,
    error
  } = _ref4;
  if (error) {
    svs.ticketsOrderHome.utils.showErrorMessage(error, next);
    throw error;
  } else {
    next();
  }
}
const orderTickets = _ref5 => {
  let {
    afterPay,
    tickets,
    onCancel,
    onDone
  } = _ref5;
  if (!(tickets !== null && tickets !== void 0 && tickets.length)) {
    return;
  }
  const priceSum = ticketsPriceSum(tickets) + svs.ticketsOrderHome.utils.constants.SHIPPING_COST;
  const price = svs.utils.format.CurrencyFromJupiterString(priceSum);
  const numberOfTickets = tickets.reduce((sum, _ref6) => {
    let {
      count
    } = _ref6;
    return sum + count;
  }, 0);
  const isPayAfterDepositEnabled = svs.core.detect.feature('ft-tickets-pay-after-deposit');
  const shouldResolveAfterPay = isPayAfterDepositEnabled && afterPay;
  let accountBalance;
  let response;
  let error;
  let latestAccountBalance;
  const calls = [{
    fn: accountServices.playerSuspension
  }, {
    in: () => ({
      spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.ALL, accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
    }),
    fn: accountServices.playerSpelpaus
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => getAccountBalanceParams({
      isPayAfterDepositEnabled,
      price
    }),
    fn: accountServices.accountBalance,
    out: args => ({
      accountBalance
    } = args)
  }, {
    fn: accountServices.playerDepositLimits
  }, {
    in: () => getConfirmPaymentOptions({
      price,
      accountBalance
    }),
    fn: shouldResolveAfterPay ? _ref7 => {
      let {
        next
      } = _ref7;
      return next();
    } : dialogs.confirmPayment
  }, {
    in: () => ({
      tickets
    }),
    fn: orderTicketsHome,
    out: args => ({
      response,
      error
    } = args)
  }, {
    in: () => ({
      response,
      error
    }),
    fn: handleOrderTicketsResult
  }, {
    fn: getLatestAccountBalance,
    out: args => ({
      latestAccountBalance
    } = args)
  }, {
    in: () => ({
      price,
      numberOfTickets,
      accountBalance: latestAccountBalance !== null && latestAccountBalance !== void 0 ? latestAccountBalance : accountBalance
    }),
    fn: shouldResolveAfterPay ? svs.ticketsOrderHome.components.afterPaymentDialog : _ref8 => {
      let {
        next
      } = _ref8;
      return next();
    }
  }];
  const cancel = () => {
    onCancel === null || onCancel === void 0 || onCancel();
  };
  const done = () => {
    onDone === null || onDone === void 0 || onDone({
      response,
      error
    });
  };
  svs.tur.pay.initPay({
    calls,
    cancel,
    done,
    shouldDisplayGeneralError: false
  });
};
setGlobal('svs.ticketsOrderHome.services.orderTickets', orderTickets);

 })(window);